import ButtonAsLink from './ButtonAsLink';

export default ButtonAsLink;
